import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/assess/task/standard/detail/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/assess/task/standard/detail/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/assess/task/standard/detail/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/assess/task/standard/detail/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/assess/task/standard/detail/submit', params,options);
